<template>
  <header v-if="screenWidth === 'mobile'" class="mobile-header">
    <div class="sidebar-header">
      <IconCrossWaitingSidebar color="#222222" @click="onCrossClickHandler" />
      <div class="sidebar-header-title">
        <span>Бронирование</span>
      </div>
      <VButton
        class="button-mobile"
        small
        outline
        @click="onButtonClickHandler"
      >
        <template #leftAddon><IconInfo color="#F18E35" /></template>
        <template #default>Детали</template>
      </VButton>
    </div>
  </header>
</template>

<script>
import IconCrossWaitingSidebar from "@/components/icons/IconCrossWaitingSidebar.vue";
import VButton from "@/components/ui/VButton.vue";
import IconInfo from "@/components/icons/IconInfo.vue";

export default {
  name: "HeaderEditBooking",
  components: {
    IconInfo,
    VButton,
    IconCrossWaitingSidebar,
  },

  methods: {
    onButtonClickHandler() {
      this.$store.commit({
        type: "toggleChooseTableEditMode",
      });
    },
    onCrossClickHandler() {
      this.$router.push(
        `/account/catering/business-booking/${this.$route.params.catId}/reservations`
      );
    },
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenType;
    },
  },
};
</script>

<style scoped lang="scss">
header {
  display: flex;
  align-items: center;
  position: relative;
  height: 64px;
  padding: 10px 24px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  z-index: 111111111;

  @include mobile {
    padding-right: 16px;
  }
}

.sidebar-header {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;

  font-weight: 400;
  font-size: 24px;
  line-height: 32px;

  svg {
    width: 24px;
    height: 24px;
  }
}

.mobile-header {
  padding: 16px;
}

.button-mobile {
  svg {
    height: 20px;
    width: 20px;
  }
}
</style>
